import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { ConfirmationView } from 'platform/forms-system/src/js/components/ConfirmationView';
import environment from '~/platform/utilities/environment';

const SubmissionContent = ({ confirmationNumber }) => {
  return (
    <p className="vads-u-margin-bottom--0">
      Your submission is in progress. Your confirmation number is{' '}
      {confirmationNumber}.
    </p>
  );
};

SubmissionContent.propTypes = {
  confirmationNumber: PropTypes.string,
};

export const ConfirmationPage = props => {
  const form = useSelector(state => state.form);
  const submission = form?.submission || {};
  const submitDate = submission?.timestamp || '';
  const confirmationNumber =
    submission?.response?.attributes?.confirmationNumber || '';

  return (
    <ConfirmationView
      formConfig={props.route?.formConfig}
      submitDate={submitDate}
      confirmationNumber={confirmationNumber}
      pdfUrl={`${environment.API_URL}/v0/education_benefits_claims/download_pdf/${submission.response?.id}`}
      devOnly={{
        showButtons: true,
      }}
    >
      <ConfirmationView.SubmissionAlert
        content={<SubmissionContent confirmationNumber={confirmationNumber} />}
        actions={null}
      />
      <va-alert status="info" uswds visible>
        <div className="usa-alert-body">
          If you changed your mailing address, your VA Profile will also be
          updated.
        </div>
      </va-alert>
      <ConfirmationView.SavePdfDownload />
      <ConfirmationView.ChapterSectionCollection />
      <ConfirmationView.PrintThisPage />
      <ConfirmationView.WhatsNextProcessList
        item1Actions={null}
        item1Content={
          <p>When we receive your form, we’ll send you an email.</p>
        }
      />
      <ConfirmationView.GoBackLink className="vads-u-margin-y--4" />
    </ConfirmationView>
  );
};

ConfirmationPage.propTypes = {
  form: PropTypes.shape({
    data: PropTypes.object,
    formId: PropTypes.string,
    submission: PropTypes.shape({
      timestamp: PropTypes.string,
    }),
  }),
  name: PropTypes.string,
  route: PropTypes.shape({
    formConfig: PropTypes.object,
  }),
};

export default ConfirmationPage;
